import { useTranslation } from 'next-i18next';

import { Button } from '@/shared/components/atoms/Button';
import { Typography } from '@/shared/components/atoms/Typography';

import UnlockIcon from '~/images/shared/Unlock.svg';

const SwitchToDesktop: React.FC<{
  handleCloseSwitchModal: () => void;
}> = ({ handleCloseSwitchModal }) => {
  const { t } = useTranslation();

  return (
    <div className='flex h-screen w-screen items-center justify-center'>
      <div className='z-[100] m-16 flex max-w-[80%] flex-col items-center justify-center gap-24 rounded-xl border-xs border-neutralVariant-90 bg-background-neutral-99 px-24 pb-24 pt-48 text-center'>
        <span>
          <UnlockIcon width='48' height='48' />
        </span>
        <div>
          <Typography variant='h2' weight='semiBold' className='mb-8'>
            {t('switch-to-desktop')}
          </Typography>
          <Typography className='text-surface-10'>
            {t('switch-to-desktop-text')}
          </Typography>
        </div>
        <Button size='full' variant='filled' onClick={handleCloseSwitchModal}>
          {t('switch-to-desktop-button')}
        </Button>
      </div>
      <div
        onClick={handleCloseSwitchModal}
        className='fixed inset-0 z-[99] h-full w-full backdrop-blur-sm'
      ></div>
    </div>
  );
};

export default SwitchToDesktop;
